import React, { Suspense } from 'react';

import InlineLoadingIndicator from '@common/components/loading-indicator/inline-loading-indicator';

import { useGetDrawerState } from '@common/components/navigation-drawer/drawer-state-context';
import { useGetRoutes } from '@aware/hooks';
import PreviewExternalLinks from '@aware/common/previews/external-links';

import AppContainer from '@common/components/app-layout/app-container';
import Main from '@common/components/app-layout/main';
import BreadcrumbProvider from '@common/components/app-layout/breadcrumb-context';

import V2NavigationDrawer from './v2-navigation-drawer';
import AppRoutes from './app-routes';

const V2Home = () => {
  const isDrawerOpen = useGetDrawerState();
  const { allRoutes } = useGetRoutes();

  return (
    <BreadcrumbProvider routes={allRoutes}>
      <AppContainer>
        <V2NavigationDrawer isDrawerOpen={isDrawerOpen} />
        <PreviewExternalLinks />

        <Main>
          <Suspense fallback={<InlineLoadingIndicator backgroundColor="transparent" />}>
            <AppRoutes />
          </Suspense>
        </Main>
      </AppContainer>
    </BreadcrumbProvider>
  );
};

export default V2Home;
